import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { Button } from '../../components/Button/Button';
import { Page } from '../../components/Page/Page';
import { TextField } from '../../components/TextField/TextField';
import { palette } from '../../theme/colors';
import type { SButtonParams, STextFieldParams } from './LegacyLogin';

export const SForm = styled.form`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
`;

export const SPage = styled(Page)`
  padding-top: 0;
  padding-bottom: 20px;
  background-color: ${props => props.theme.palette.background.primary};
`;

export const SUserImg = styled.img`
  margin: 0 auto;
  display: block;
  min-width: 13rem;
  min-height: 15.6rem;
`;

export const SFaTwoEmptyBox = styled.div`
  height: 55.5px;
`;

export const SLoginEmptyBox = styled.div`
  height: 24px;
`;

export const STextField = styled(TextField)<STextFieldParams>`
  ${props =>
    props.disabled &&
    css`
      opacity: 0.5;
    `}
  input {
    color: ${palette.grayx11gray};
    font-family: 'Roboto-Regular';
    font-size: 1rem;
    ${props =>
      props.error &&
      css`
        border-color: ${palette.tartOrange};
      `}
  }
  input::placeholder {
    font-size: 1rem;
    font-family: 'Roboto-Regular';
    color: ${palette.grayx11gray};
  }

  &.email {
    margin-bottom: 0.625rem;
  }
`;

export const STitle = styled.h1<{ $loginMethodTitle?: boolean }>`
  font-size: 1.125rem;
  font-family: 'Roboto-Medium';
  color: ${palette.silver};
  text-align: left;
  padding-left: 4px;
  margin: 1rem auto 1rem auto;

  ${props =>
    props.$loginMethodTitle &&
    css`
      font-size: 1.375rem;
      margin: 3rem auto 1rem auto;
    `}
`;

export const SForgotPassLink = styled(Link)`
  font-size: 0.875rem;
  font-family: 'Roboto-Regular';
  color: ${palette.honeyYellow};
  text-decoration: none;
`;

export const SErrorText = styled.p`
  font-size: 0.875rem;
  font-family: 'Roboto-Regular';
  color: ${palette.tartOrange};
  margin-right: auto;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const STextContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  place-content: flex-end;
  margin-top: 0.625rem;
`;

export const SSSoLink = styled(Link)`
  text-decoration: none;
  align-self: center;
  font-size: 1rem;
  font-family: 'Roboto-Regular';
  color: ${palette.honeyYellow};
  margin: 2rem 0 1.75rem 0;
  cursor: pointer;
`;

export const SPrivacyText = styled.p`
  text-align: center;
  max-width: 80%;
  font-size: 1rem;
  font-family: 'Roboto-Regular';
  margin: 1.75rem auto 0 auto;
  color: ${palette.silver};
`;

export const SLink = styled.a`
  color: ${palette.honeyYellow};
  text-decoration: none;
`;

export const SButton = styled(Button)<SButtonParams>`
  width: 100%;
  margin-top: 1rem;
  button {
    max-width: 200rem;
    height: 3.125rem;
    border-radius: 25px;
    ${props =>
      props.$error &&
      css`
        opacity: 0.5;
      `}

    ${props =>
      props.$textOnly &&
      css`
        background-color: ${palette.transparent};
        color: ${palette.honeyYellow};
      `}
    ${props =>
      props.disabled &&
      css`
        color: ${palette.silver};
        opacity: 0.5;
      `}

    ${props =>
      props.$cosafeLogin &&
      css`
        color: ${palette.prussianBlue};
      `}

    ${props =>
      props.$ssoLogin &&
      css`
        background-color: ${palette.policeBlueish};

        color: ${palette.white};
      `}
  }
`;

export const SOption = styled.div`
  display: flex;
  place-content: space-between;
  margin-top: 15px;

  p {
    font-family: 'Roboto-Regular';
    line-height: 21px;
    place-self: center;
  }
`;

export const Switch = styled.label`
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  input:checked + span:before {
    transform: translateX(26px);
    background-color: ${palette.honeyYellow};
  }

  span {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #34415a;
    border-radius: 34px;

    &:before {
      position: absolute;
      content: '';
      height: 26px;
      width: 26px;
      left: 4px;
      bottom: 4px;
      background-color: ${palette.white};
      border-radius: 50%;
    }
  }
`;

export const SDescription = styled.p`
  font-size: 1rem;
  font-family: 'Roboto-Regular';
  color: ${palette.grayx11gray};
  margin-bottom: 1.6rem;
  padding-left: 4px;
`;
